export default "__VITE_ASSET__CfnLSrgR__"